// PageSubscription Component

import React from 'react'
import async from 'async'
import _ from 'lodash'

import app from '../../../app.jsx'
import Acl from '../../../lib/acl.jsx'
import SubscriptionContent from '../../../setting/subscription/subscription_content/subscription_content.jsx'
import DialogPaymentMessage from '../../../setting/dialog/dialog_payment_message/dialog_payment_message.jsx'
import DialogSubscriptionAddress from '../../../setting/dialog/dialog_subscription_address/dialog_subscription_address.jsx'
import DialogTeamCancel from '../../dialog/dialog_teamcancel/dialog_teamcancel.jsx'
import DialogCommon from '../../../common/dialog/dialog_common/dialog_common.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import BaseSettings from '../../page/base_setting/base_setting.jsx'
import { ThemeProvider, lightTheme } from '@rodeo-dev/legos'

class PageSubscription extends BaseSettings {
  constructor (props) {
    super(props, 'setting-subscription', 'setting-user', 'setting-subscription')

    this.state = {
      dataDate: null
    }

    this.data = {
      teamId: app.getTeamId(),
      team: null,
      user: null,
      subscriptionUpcoming: null,
      idealIssuers: [],
      histories: []
    }

    this._references = {
      refDialogTeamCancel: React.createRef(),
      pageHeader: React.createRef(),
      refDialogPaymentMessage: React.createRef(),
      teamAddressDialog: React.createRef(),
      dialogCommon: React.createRef()
    }

    this._bUnMounted = false
    this._bTeamTrail = app.isTrail()
  }

  componentDidMount () {
    this.setState({ isLoading: true })
    this._getData()

    if (this.props.messageType) {
      this._showMessage()
    }
  }

  componentWillUnmount () {
    this._bUnMounted = true
  }

  renderContent () {
    const { team, user } = this.data

    return (
      <ThemeProvider theme={lightTheme}>
        <div className='page-subscription'>
          {this.data.team && this.data.subscriptionUpcoming && (
            <SubscriptionContent
              user={user}
              team={team}
              subscriptionUpcoming={this.data.subscriptionUpcoming}
              issuers={this.data.idealIssuers}
              isTeamUSA={app.teamCountry === 'US'}
              isTrail={this._bTeamTrail}
              onQuickbookPayment={this._onQuickbookPayment.bind(this)}
              onActivatePlanner={this._onActivatePlanner.bind(this)}
              onActivateInternalExpenses={this._onActivateInternalExpenses.bind(this)}
              onError={this._onError.bind(this)}
              onCancelAccount={this._onCancelAccount.bind(this)}
              histories={this.data.histories}
              onClickDownload={this._onClickDownload.bind(this)}
            />
          )}
          {this._renderMessage()}
          <DialogTeamCancel
            ref={this._references.refDialogTeamCancel}
            onClose={this._onClose.bind(this)}
            onConfirm={this._onConfirmCancelAccount.bind(this)}
          />
          <DialogSubscriptionAddress
            ref={this._references.teamAddressDialog}
            teamCountry={app.teamCountry}
            onSubmit={this._onSubmitAddressSubscription.bind(this)}
          />
          <DialogCommon
            ref={this._references.dialogCommon}
            className='subscription-confirm'
            title='setting.form.commomDialogTitle'
            message='setting.form.commonDialogMessage'
            onOk={this._onConfirmQuickbookPayment.bind(this)}
            onCancel={this._onCloseQuickbookPayment.bind(this)}
            showClose={false}
            showCancel
            active={false}
            showLeftPanel={false}
            type='normal'
          />
        </div>
      </ThemeProvider>
    )
  }

  getContentClassname () {
    return 'full'
  }

  _renderMessage () {
    if (this.props.messageType) {
      return (
        <DialogPaymentMessage ref={this._references.refDialogPaymentMessage} />
      )
    }

    return ''
  }

  /* Event Handlers */
  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  _onActivatePlanner (isPlannerAllowed) {
    return this._updatePlannerEnabled(
      this.data.teamId,
      { isPlannerAllowed },
      {}
    )
  }

  _onActivateInternalExpenses (isInternalExpensesAllowed) {
    return this._updateInternalExpensesEnabled(
      this.data.teamId,
      { isInternalExpensesAllowed },
      {}
    )
  }

  _updatePlannerEnabled (teamId, updateObj) {
    return this._updateSubscriptionFeatures({
      planner: updateObj.isPlannerAllowed
    })
      .then(_res => {
        Acl.setPlannerAllowed(updateObj.isPlannerAllowed)
        app.redirect('/user/subscription')
      })
      .catch(err => {
        app.debug('PageSubscription: _onConfirm err', err)
      })
  }

  _updateInternalExpensesEnabled (teamId, updateObj) {
    return this._updateSubscriptionFeatures({
      internalExpenses: updateObj.isInternalExpensesAllowed
    })
      .then((_res) => {
        Acl.setInternalExpensesAllowed(updateObj.isInternalExpensesAllowed)
        app.redirect('/user/subscription')
      })
      .catch((err) => {
        app.debug('PageSubscription: _onConfirm err', err)
      })
  }

  _updateSubscriptionFeatures (features) {
    const team = app.getTeam()
    const countryCode = team.profile.country

    return app.service('/api/subscription/features').patch(app.getTeamId(), {
      features,
      countryCode
    })
  }

  _onSubmitAddressSubscription (updateObj) {
    const data = {
      street: updateObj.street,
      postcode: updateObj.postcode,
      city: updateObj.city,
      state: updateObj.state
    }

    return app
      .service('/api/team')
      .get(this.data.teamId)
      .then(teamRes => {
        const profile = { ...teamRes.profile, ...data }

        if (this._references.teamAddressDialog.current) {
          this._references.teamAddressDialog.current.hide()
        }

        return app.service('/api/team').patch(this.data.teamId, { profile })
      })
      .then(_res => {
        // Show confirm dialog
        this._showQuickbookConfirm()
      })
      .catch(errRes => {
        app.debug('PageSubscription: _onSubmit err', errRes)
      })
  }

  _onQuickbookPayment () {
    const { team } = this.data
    const profile = team.profile || {}

    if (
      !profile.street ||
      !profile.postcode ||
      !profile.city ||
      !profile.state
    ) {
      const updateObj = {
        street: profile.street,
        postcode: profile.postcode,
        city: profile.city,
        state: profile.state
      }
      if (this._references.teamAddressDialog.current) {
        this._references.teamAddressDialog.current.show(updateObj)
      }
    } else {
      // Show confirm dialog
      this._showQuickbookConfirm()
    }
  }

  _showQuickbookConfirm () {
    if (this._references.dialogCommon.current) {
      this._references.dialogCommon.current.show()
    }
  }

  _onConfirmQuickbookPayment () {
    this._triggerQuickbookPayment()
  }

  _onCloseQuickbookPayment () {
    if (this._references.dialogCommon.current) {
      this._references.dialogCommon.current.hide()
    }
  }

  _triggerQuickbookPayment () {
    const paymentData = {
      teamId: this.data.teamId,
      bRenew: false,
      clientTimezoneOffset: DateUtil.getLocalTimezoneOffset()
    }

    app
      .service('/api/quickbook/subscription')
      .create(paymentData)
      .then(_payRes => {
        if (this._references.dialogCommon.current) {
          this._references.dialogCommon.current.hide()
        }

        this._getData()
      })
      .catch(payErr => {
        app.debug('PageSubscription _onQuickbookPayment err', payErr)
        this._onError('setting.subscription.msgErrorUpgrade')
      })
  }

  _onError (field) {
    if (this._references.pageHeader.current) {
      this._references.pageHeader.current.showError(
        'setting.subscription.msgErrorTitle',
        field || 'setting.subscription.msgErrorInfo'
      )
    }
  }

  _onCancelAccount () {
    if (this._references.refDialogTeamCancel.current) {
      this._references.refDialogTeamCancel.current.show()
    }
  }

  _onClose (ev) {
    ev.preventDefault()

    if (this._references.refDialogTeamCancel.current) {
      this._references.refDialogTeamCancel.current.hide()
    }
  }

  _onClickDownload ({ historyId, invoiceNo, isSubscriptionV2 }) {
    const team = this.data.team
    if (isSubscriptionV2) {
      app.redirect(`/subscription_v2/download/${invoiceNo}/${team.id}`)
      return
    }

    // This can possibly be removed in case all past PDFs have been pre-generated for the invoice e-mails already
    app
      .service('/api/console/subscription')
      .patch(team.id, { action: 'preview', historyId: historyId })
      .then(_previewRes => {
        if (historyId) {
          app.redirect(`/subscription/download/${historyId}`)
        }
      })
      .catch(previewErr => {
        app.debug('PageSubscription: _onClickDownload err', previewErr)
      })
  }

  _onConfirmCancelAccount () {
    app
      .service('/api/subscription/cancel')
      .patch(this.data.teamId, {})
      .then(() => {
        app.logout()
        app.redirect('/blocked/')
      })
      .catch(err => {
        app.debug('PageSubscription: _onConfirmAccount err', err)
      })
  }

  /* Private Functions */
  _getData () {
    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this._getDataUserTeam(done)
        },
        done => {
          this._getDataTeam(done)
        },
        done => {
          this._getDataSubscriptionUpcoming(done)
        },
        done => {
          this._getDataIdealIssuer(done)
        },
        done => {
          this._getDataSubscriptionHistories(done)
        },
        done => {
          this._getDataHalfUsers(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _getDataUserTeam (callback) {
    const findParams = {
      query: {
        userId: app.loggedInId,
        teamId: app.getTeamId()
      }
    }

    app
      .service('/api/users/team')
      .find(findParams)
      .then(result => {
        if (result.data && result.data.length > 0) {
          this.data.user = result.data[0]
          callback(null)
        } else {
          callback('Invalid user details') // eslint-disable-line standard/no-callback-literal
        }
      })
      .catch(err => {
        callback(err)
      })
  }

  _getDataTeam (callback) {
    app
      .service('/api/team')
      .get(this.data.teamId)
      .then(teamRes => {
        this.data.team = teamRes
        callback(null)
      })
      .catch(teamErr => {
        app.debug('PageSubscription: _getDataTeam err', teamErr)
        callback(teamErr)
      })
  }

  _getDataSubscriptionUpcoming (callback) {
    app
      .service('/api/subscription/upcoming')
      .find()
      .then(subsUpcomingRes => {
        this.data.subscriptionUpcoming =
          subsUpcomingRes && subsUpcomingRes.total > 0
            ? subsUpcomingRes.data[0]
            : { items: [] }

        callback(null)
      })
      .catch(subsUpcomingErr => {
        app.debug(
          'PageSubscription: _getDataSubscriptionUpcoming err',
          subsUpcomingErr
        )
        callback(subsUpcomingErr)
      })
  }

  _getDataIdealIssuer (callback) {
    const subscription = this.data.team ? this.data.team.subscription : null
    if (
      this.data.team &&
      subscription.status === 'active' &&
      !subscription.isExpired
    ) {
      callback(null)
      return true
    }

    app
      .service('/api/payment/idealissuer')
      .find({})
      .then(idealIssuerRes => {
        if (idealIssuerRes && idealIssuerRes.total > 0) {
          this.data.idealIssuers = []
          idealIssuerRes.data.map(idealIssuer => {
            this.data.idealIssuers.push({
              label: idealIssuer.name,
              value: idealIssuer.id
            })
          })
        }
        callback(null)
      })
      .catch(idealIssuerErr => {
        app.debug('PageSubscription: _getDataIdealIssuer err', idealIssuerErr)
        callback(idealIssuerErr)
      })
  }

  _getDataSubscriptionHistories (callback) {
    const params = {
      query: {
        status: 'Paid',
        $sort: { createdOn: -1 }
      }
    }

    app
      .service('/api/subscription/history')
      .find(params)
      .then(hisRes => {
        if (hisRes && hisRes.data && hisRes.total > 0) {
          this.data.histories = hisRes.data
        }

        callback(null)
      })
      .catch(hisErr => {
        app.debug('PageSubscription: _getDataSubscriptionHistories err', hisErr)
        callback(hisErr)
      })
  }

  _getDataHalfUsers (callback) {
    const userIds = []
    const items = this.data.subscriptionUpcoming
      ? this.data.subscriptionUpcoming.items
      : []

    items.map(item => {
      if (item.type !== 'Planner' && item.type !== 'Internal Expenses' && item.isPostPaid && item.users.length > 0) {
        item.users.map(userItem => {
          userIds.push(userItem.userId)
        })
      }
    })

    if (userIds.length > 0) {
      const userTeamParams = {
        query: {
          teamId: this.data.teamId,
          userId: userIds
        }
      }

      return app
        .service('/api/users/team')
        .find(userTeamParams)
        .then(userTeamRes => {
          if (userTeamRes && userTeamRes.data.length > 0) {
            const userTeamMap = {}
            userTeamRes.data.map(userTeam => {
              userTeamMap[userTeam.userId.toString()] = userTeam
            })

            const newItems = []
            this.data.subscriptionUpcoming.items.map(item => {
              if (
                item.type !== 'Planner' &&
                item.isPostPaid &&
                item.users.length > 0
              ) {
                item.users.map(userItem => {
                  const newItem = _.cloneDeep(item)
                  newItem.noUsers = 1
                  newItem.total = item.pricePerUser

                  const userName = userTeamMap[userItem.userId.toString()]
                    ? userTeamMap[userItem.userId.toString()].firstName
                    : '-'
                  const userType =
                    item.type === 'Full' ? 'full user' : 'standard user'
                  newItem.title = `Post paid ${userType} (${userName} added ${DateUtil.getDisplayDate(
                    item.fromDate
                  )})`

                  newItems.push(newItem)
                })
              } else {
                newItems.push(item)
              }
            })

            this.data.subscriptionUpcoming.items = newItems
          }

          callback(null)
        })
        .catch(hisErr => {
          app.debug('PageSubscription: _getDataHalfUsers err', hisErr)
          callback(hisErr)
        })
    } else {
      callback(null)
    }
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return
    this.setState({ isLoading: false })

    if (err) {
      app.debug('PageSubscription: _onDataReceived Error', err)
      this.setState({ dataDate: new Date() })
    } else {
      app.debug('PageSubscription: _onDataReceived [done]')
      this.setState({ dataDate: new Date() })
    }
  }

  _showMessage () {
    if (!this._references.refDialogPaymentMessage.current) {
      return false
    }

    const type = this.props.messageType
    const message = 'setting.subscription.contentMessage'
    if (type === 'success') {
      this._references.refDialogPaymentMessage.current.show(
        'setting.subscription.successPayment',
        '',
        false
      )
    } else if (type === 'error') {
      this._references.refDialogPaymentMessage.current.show(
        'setting.subscription.errorMsgPayment',
        message,
        true
      )
    }
  }
}

export default PageSubscription
